import React from 'react';
import logo from './logo.svg';
import './App.css';
import Card from './card';
import Gift from './gift';

function App() {
  return (
    <div className="App">
      <Gift />
      <div className="heino">
        <h2>Tillykke med de <span id="small">25+30=</span>55 år!</h2>
        <img id='image' src="https://dit-gentofte.dk/wp-content/uploads/2026/06/Forsalget_til_The_Odyssey_i_70mm_er_startet_html_3_14a64f646759.jpg" alt="Heino Hansen" />
        <p>Sæt kryds i kalenderen den</p>
        <h3>-- indsæt dato her --</h3>
        <div className='gift_list'>
          <p><span id='bold'>2 x</span> Mad på Meatery</p>
          <p><span id='bold'>2 x</span> Billetter til The Odyssey</p>
        </div>
        {/* <p>Din gave er at vi (Dig, Nicolai, Thor og Clara) skal se Heino Hansen og spise på Boulion i københavn d. 5. April</p> */}
      </div>
    </div>
  );
}

export default App;
